import React, { ReactElement } from "react";
import { createPortal } from "react-dom";

type Position = "bottom-right" | "center";

interface ModalProps {
  children: ReactElement;
  contentPosition: Position;
  onClose: (status: "modal-closed") => void;
}

const Modal:any = (props: ModalProps) => {
  const modal = document.querySelector("#modal");

  if (!modal) return null;

  const { contentPosition } = props;

  return createPortal(
    <div
      className={`fixed top-0 w-screen h-full flex md:p-[30px] z-modal bg-black/30 overflow-y-auto ${
        contentPosition === "bottom-right" ? "justify-end items-end" : ""
      } ${contentPosition === "center" ? "justify-center items-baseline" : ""}`}
      role="button"
      onClick={(event) => {
        event.stopPropagation();
        props.onClose("modal-closed");
      }}
    >
      {props.children}
    </div>,
    modal
  );
};

export default Modal;
